import lv10012 from "./lv10012";



const { ccclass, property } = cc._decorator;

export interface ViewAnswer012 {
    index: number,
    id: string,//唯一标识id
    node: cc.Node,//节点对象
    img: string,//图片信息
    compelete: boolean,//是否已经完成
    put: string,//上面放入了的答案id
    canMove: boolean,//是否可以移动
    price?: number
}
@ccclass
export default class view_012 extends cc.Component {


    @property({ type: cc.Node, displayName: '答案框父节点' })
    windowParent: cc.Node = null;


    @property({ type: [cc.Node], displayName: "答案对象列表" })
    answerNode: cc.Node[] = [];

    @property({ type: cc.Node, displayName: '聊天信息' })
    chatInfo: cc.Node = null;

    /** 关卡脚本 */
    levelScripte: lv10012 = null;

    readonly answerImgList: string[] = [

    ];//答案图列表

    readonly clickSoundList: string[] = [

    ];//答案显示后的音效播放

    readonly showChatList: string[] = [

    ];//答案显示后的对话文本

    readonly imgListUrl: string = 'res/'

    viewAnswerInfo: ViewAnswer012[] = [];//场景中的所有答案对象信息

    windowAnswerInfo: ViewAnswer012[] = [];//答案框所有对象信息



    m_currClickInfo: ViewAnswer012 = null;

    m_touchStartTime: number = 0;

    protected compeleteCall: () => void = null;

    protected bundleName: string = '';

    protected canClick: boolean = true;

    protected maskNode: cc.Node = null;
    protected gameNode: cc.Node = null;

    initLevel(bundle: string) {
        this.maskNode = this.node.getChildByName("Mask");
        this.gameNode = this.maskNode.getChildByName("game");
        this.levelScripte = this.node.parent.getComponent(lv10012);
        this.bundleName = bundle;
        //场景对象初始化
        for (let i = 0; i < this.answerNode.length; i++) {
            const nd = this.answerNode[i];
            const info: ViewAnswer012 = {
                id: 'an' + i,
                node: nd,
                img: i.toString(),
                compelete: false,
                put: null,
                canMove: false,
                index: i
            }
            this.viewAnswerInfo.push(info);
            nd.on(cc.Node.EventType.TOUCH_START, (e) => {
                this.onTouchStartViewAnswer(e, info);
            })
            nd.on(cc.Node.EventType.TOUCH_MOVE, (e) => {
                this.onTouchMoveViewAnswer(e, info);
            })
            nd.on(cc.Node.EventType.TOUCH_END, (e) => {
                this.onTouchEndViewAnswer(e, info);
            })
            nd.on(cc.Node.EventType.TOUCH_CANCEL, (e) => {
                this.onTouchEndViewAnswer(e, info);
            })
        }

        //答案对象初始化
        for (let j = 0; j < this.windowParent.childrenCount; j++) {
            const nd = this.windowParent.children[j];
            const info: ViewAnswer012 = {
                id: 'kk' + j,
                node: nd,
                img: null,
                compelete: false,
                put: null,
                canMove: false,
                index: j
            }
            this.windowAnswerInfo.push(info);
        }

    }


    onTouchStartViewAnswer(e: cc.Event.EventTouch, info: ViewAnswer012) {
        e.stopPropagation();
        if (!this.canClick) {
            return
        }
        const data = new Date();
        this.m_currClickInfo = info;
        this.m_touchStartTime = data.getTime();
    }


    onTouchMoveViewAnswer(e: cc.Event.EventTouch, info: ViewAnswer012) {
        e.stopPropagation();
        if (!this.canClick) {
            return
        }
        const det = e.getDelta();
        if (info.canMove) {
            info.node.x += det.x;
            info.node.y += det.y;
        }
    }

    onTouchEndViewAnswer(e: cc.Event.EventTouch, info: ViewAnswer012) {
        e.stopPropagation();
        if (!this.canClick || info.compelete) {
            return
        }
        if (this.m_currClickInfo && this.m_currClickInfo.id == info.id) {
            this.m_currClickInfo = null;
        }


        this.touchInfoCall(info);

        // const data=new Date();
        // data.getTime();
    }

    touchInfoCall(info: ViewAnswer012) {
        //managers().soundMgr.playSound(this.clickSoundList[info.index])
        this.compeleteInfo(info);
    }

    /**完成一个 */
    compeleteInfo(info: ViewAnswer012) {
        let willInfo: ViewAnswer012 = null
        for (let i = 0; i < this.windowAnswerInfo.length; i++) {
            const checkInfo = this.windowAnswerInfo[i];
            if (checkInfo.compelete || willInfo != null) {
                continue
            }
            willInfo = checkInfo;
        }
        this.canClick = false;
        info.compelete = true;
        willInfo.compelete = true;
        const nd = cc.instantiate(info.node);
        const pos = this.node.convertToNodeSpaceAR(info.node.parent.convertToWorldSpaceAR(cc.v2(info.node.x, info.node.y)));
        nd.setPosition(pos);
        this.node.addChild(nd);
        const topos = this.node.convertToNodeSpaceAR(willInfo.node.parent.convertToWorldSpaceAR(cc.v2(willInfo.node.x, willInfo.node.y)))
        cc.tween(nd).to(0.3, {
            x: topos.x,
            y: topos.y,
        }).call(() => {
            this.canClick = true;
            // nd.destroy()
            this.loadAnswerImg(info.img, willInfo.node.getChildByName('img').getComponent(cc.Sprite));
            this.checkWinOver();
        }).start()
    }


    loadAnswerImg(url: string, img: cc.Sprite) {
        // return
        const bundle = cc.assetManager.getBundle(this.bundleName);
        bundle.load(this.imgListUrl + url, cc.Texture2D, (e, ass: cc.Texture2D) => {
            if (e) {
                console.warn("没有图片", e)
                return
            }
            const frame = new cc.SpriteFrame(ass);
            img.spriteFrame = frame;
        })
    }


    showChat(say: string, time: number = 1) {
        if (say == null || say == '') {
            this.chatInfo.stopAllActions();
            this.chatInfo.active = true;
            this.chatInfo.opacity = 0;
            return
        }
        this.chatInfo.getChildByName("labelInfo").children[0].getComponent(cc.Label).string = say;
        this.chatInfo.active = true;
        this.chatInfo.stopAllActions();
        this.chatInfo.opacity = 0;
        cc.tween(this.chatInfo).to(0.2, { opacity: 255 }).delay(time).to(2, { opacity: 0 }).start();
    }


    checkWinOver() {
        let win: boolean = true;
        for (let i = 0; i < this.windowAnswerInfo.length; i++) {
            if (this.windowAnswerInfo[i].compelete == false) {
                win = false;
                break;
            }
        }
        if (win) {
            this.levelScripte.switchScene();
        }
    }

    // update (dt) {}
}
